module.exports = __webpack_public_path__ + "static/img/logo-ms.1a9478c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/logo-ms.png
// module id = X0HM
// module chunks = 1